import { Typography } from '@mui/material';
import {
  fetchRegistration,
  getSubmissionEntries,
  SubmissionEntry,
} from 'actions/challenge';
import { fetchTeam } from 'actions/team';
import Loading from 'components/Loading';
import SubmissionsList from 'components/SubmissionsList';
import LeaderboardContext from 'contexts/leaderboard';
import UserContext from 'contexts/user';
import DefaultLayout from 'layouts/default';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Team } from 'types/team';
import { Registration } from 'types/user';
import './index.css';
type PastSubmissionsPageProps = {};
const PastSubmissionsPage = ({}: PastSubmissionsPageProps) => {
  const { user } = useContext(UserContext);
  const [registration, setRegistration] = useState<Registration>();
  const [team, setTeam] = useState<Team>();
  const { leaderboards, getChallenge } = useContext(LeaderboardContext);
  const [submissionData, setSubmissionData] = useState<SubmissionEntry[]>();
  const params = useParams<{ challengeId: string }>();
  useEffect(() => {
    getChallenge([params.challengeId]);
    getSubmissionEntries(params.challengeId).then((data) => {
      setSubmissionData(data);
    });
  }, [params.challengeId]);
  useEffect(() => {
    fetchRegistration(params.challengeId).then((registration) => {
      setRegistration(registration);
    });
  }, [params.challengeId]);
  useEffect(() => {
    if (registration) {
      fetchTeam(params.challengeId).then((team) => {
        setTeam(team);
      });
    }
  }, [registration, params.challengeId]);
  if (!registration || !leaderboards[params.challengeId] || !submissionData) {
    return (
      <DefaultLayout>
        <Loading text="Loading Leaderboard" />
      </DefaultLayout>
    );
  }
  return (
    <DefaultLayout>
      <div className="PastSubmissionsPage">
        <Typography variant="h4">
          Past Submissions for {leaderboards[params.challengeId].name}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {registration.teamId
            ? team && (
                <>
                  Currently in team <strong>{team?.teamName}</strong>
                </>
              )
            : 'No Team'}
        </Typography>
        {leaderboards[params.challengeId] && (
          <SubmissionsList
            data={submissionData}
            showProgress
            metrics={leaderboards[params.challengeId].metrics}
          />
        )}
      </div>
    </DefaultLayout>
  );
};

export default PastSubmissionsPage;
